import React from 'react';
import { RoomDevice } from '../../services/rooms';
import { DeviceInfo } from '../../services/n8n';

interface Props {
  personaId: string;
  value?: string;
  roomId: string | null;
  roomDevices: RoomDevice[];
  allDevices: DeviceInfo[];
  disabled?: boolean;
  onChange: (deviceId: string) => void;
  className?: string;
}

// Device dropdown for one seat — used in Cast Setup, the Run Console and
// Results so a device_voice persona can be (re)paired to a physical device
// at any point before, during, or after a run.
const SeatDeviceSelect: React.FC<Props> = ({ personaId, value, roomId, roomDevices, allDevices, disabled, onChange, className }) => (
  <select
    value={value || ''}
    onChange={e => onChange(e.target.value)}
    disabled={disabled || !roomId}
    className={className || 'w-full rounded-lg border border-slate-200 px-2 py-1.5 text-xs text-navy disabled:bg-slate-50 disabled:text-slate-300'}
  >
    <option value="">{roomId ? 'Unpaired' : 'Bind a room first'}</option>
    {roomDevices.map(rd => {
      const info = allDevices.find(d => d.deviceId === rd.deviceId);
      const takenBy = info?.assignedRole && info.assignedRole !== personaId ? ` (paired to ${info.assignedRole})` : '';
      return (
        <option key={rd.deviceId} value={rd.deviceId}>
          {info?.displayName || rd.deviceId}{takenBy}
        </option>
      );
    })}
  </select>
);

export default SeatDeviceSelect;
